import styled from "styled-components";

export const Path = styled.path`
    fill:${({color='primary'})=>`var(--bs-${color})`};
`;